const initialState = {
  list: [],
  selected: null,
  loading: false,
  error: null
}

const locationTestReducer = (state = initialState, action) => {
  switch (action.type) {
    case "LOCATION_TEST_LOADING":
      return { ...state, loading: true, error: null }
    case "GET_ALL_LOCATION_TESTS": {
      const payload = action.data
      const items =
        (Array.isArray(payload?.data?.items) && payload.data.items) ||
        (Array.isArray(payload?.data?.data) && payload.data.data) ||
        (Array.isArray(payload?.data?.locationTests) && payload.data.locationTests) ||
        (Array.isArray(payload?.data) && payload.data) ||
        (Array.isArray(payload?.items) && payload.items) ||
        (Array.isArray(payload?.locationTests) && payload.locationTests) ||
        (Array.isArray(payload) && payload) ||
        []
      return { ...state, list: items, loading: false, error: null }
    }
    case "GET_LOCATION_TEST_BY_ID": {
      const payload = action.data
      // Handle various response structures
      const selectedData =
        payload?.data?.locationTests?.[0] ||
        payload?.data?.locationTest ||
        payload?.data?.location_test ||
        payload?.data ||
        payload?.locationTests?.[0] ||
        payload?.locationTest ||
        payload?.location_test ||
        payload
      return { ...state, selected: selectedData || null, loading: false }
    }
    default:
      return state
  }
}

export default locationTestReducer
